import { Heading, Panel } from '@savgroup-front-common/core';

const AdministrationPage = () => {
  return (
    <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
      <Heading level={1}>
        Administration
      </Heading>
      <div style={{ marginTop: '2rem' }}>
        <Panel>
          <Heading level={2}>
            Administration
          </Heading>
          <p>Contenu de la page Administration à venir...</p>
        </Panel>
      </div>
    </div>
  );
};

export default AdministrationPage;
